{
  "fields": {
    "switch": {
      "on": "Ja",
      "off": "Nein"
    },
    "search": {
      "placeholder": "Suchen..."
    }
  }
}
